<template>
  <vca-column>
    <vca-dropdown
      :taggable="true"
      v-model="artists"
      :options="artistList"
      :rules="$v.artists"
      ref="artist"
      label=""
      :placeholder="$t('network.artists.name.placeholder')"
      :errorMsg="$t('network.artists.name.errorMsg')"
    ></vca-dropdown>
    <button :disabled="!isUnique" class="vca-button" @click="add()">
      {{ $t("button.save") }}
    </button>
  </vca-column>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
export default {
  name: "ArtistDropdown",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters({
      artistList: "artists/artistList",
    }),
    isUnique() {
      return (
        this.value &&
        !this.artistList.find(
          (el) => el.label.toLowerCase() == this.value.toLowerCase()
        )
      );
    },
    artists: {
      get() {
        return this.value
          ? [
              {
                value: this.value,
                title: this.value,
                label: this.value,
              },
            ]
          : [];
      },
      set(value) {
        let doesExist;
        let emitValue;

        if (!value[0]) {
          emitValue = "";
        } else if (typeof value[0] === "string") {
          doesExist = this.artistList.find(
            (el) => el.label.toLowerCase() == value[0].toLowerCase()
          );
          emitValue = value[0];
        } else {
          doesExist = this.artistList.find(
            (el) => el.label.toLowerCase() == value[0].label.toLowerCase()
          );
          emitValue = value[0].label;
        }

        if (doesExist) {
          this.$emit("input", doesExist.label);
        } else {
          this.$emit("input", emitValue);
        }
        this.$refs.artist.validate();
      },
    },
  },
  validations() {
    return {
      artists: {
        required,
        isUnique(value) {
          const doesExist = this.artistList.find(
            (el) => el.label.toLowerCase() == value[0].label.toLowerCase()
          );
          return doesExist == undefined;
        },
      },
    };
  },
  methods: {
    validate() {
      this.$refs.artist.validate();
    },
    add() {
      this.$emit("add");
    },
  },
};
</script>
